// @ts-nocheck

import styled from 'styled-components'
import highcharts from 'highcharts'
import HighchartsReact from 'highcharts-react-official'

interface NameData {
  name: string
  data: number
}

export interface HorizontalBarChartData {
  name: string
  data: (NameData | number)[]
}

interface HorisontalBarChartProps {
  title?: string
  subTitle?: string
  xAxisLabel?: string
  yAxisLabel?: string
  categories?: string[]
  data?: HorizontalBarChartData[]
  startDate?: string
  colors?: string[]
}

export const HorisontalBarChart = ({
  title,
  subTitle,
  xAxisLabel,
  yAxisLabel,
  categories,
  data,
  colors,
}: HorisontalBarChartProps) => {
  const config = {
    chart: {
      height: 450,
      type: 'bar',
    },
    title: {
      text: title,
      align: 'left',
    },
    subtitle: {
      text: subTitle,
      align: 'left',
    },
    yAxis: {
      title: {
        text: yAxisLabel,
      },
    },
    xAxis: {
      categories,
      title: {
        text: xAxisLabel,
      },
    },
    tooltip: {
      valueDecimals: 0,
    },
    plotOptions: {
      series: {
        stacking: 'normal',
        // dataLabels: {
        //     enabled: true
        // }
      },
    },
    credits: {
      enabled: false,
    },
    series: data,
    colors,
  }
  return (
    <Container>
      <HighchartsReact highcharts={highcharts} options={config} />
    </Container>
  )
}

export default HorisontalBarChart

const Container = styled.div`
  border-radius: 25px;
  background-size: 90%;
  background-position-x: 35%;
  background-position-y: center;
  background-repeat: no-repeat;
  color: ${({ theme }) => theme.color.neutral.color11};

  ${({ theme }) => theme.mediaQueries.mobileDown} {
    background-size: 250%;
    background-position-x: 5%;
    background-position-y: bottom;
  }
`
